var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-can",
    clipPath: "url(#clip0_881_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.82812 2.44062L5.23438 3.32812H9.76562L9.17188 2.44062C9.125 2.37187 9.04688 2.32812 8.9625 2.32812H6.03438C5.95 2.32812 5.87187 2.36875 5.825 2.44062H5.82812ZM10.4219 1.60938L11.5688 3.32812H12H13.5H13.75C14.1656 3.32812 14.5 3.6625 14.5 4.07812C14.5 4.49375 14.1656 4.82812 13.75 4.82812H13.5V14.3281C13.5 15.7094 12.3813 16.8281 11 16.8281H4C2.61875 16.8281 1.5 15.7094 1.5 14.3281V4.82812H1.25C0.834375 4.82812 0.5 4.49375 0.5 4.07812C0.5 3.6625 0.834375 3.32812 1.25 3.32812H1.5H3H3.43125L4.57812 1.60625C4.90312 1.12187 5.45 0.828125 6.03438 0.828125H8.9625C9.54688 0.828125 10.0938 1.12187 10.4187 1.60625L10.4219 1.60938ZM3 4.82812V14.3281C3 14.8813 3.44688 15.3281 4 15.3281H11C11.5531 15.3281 12 14.8813 12 14.3281V4.82812H3ZM5.5 6.82812V13.3281C5.5 13.6031 5.275 13.8281 5 13.8281C4.725 13.8281 4.5 13.6031 4.5 13.3281V6.82812C4.5 6.55312 4.725 6.32812 5 6.32812C5.275 6.32812 5.5 6.55312 5.5 6.82812ZM8 6.82812V13.3281C8 13.6031 7.775 13.8281 7.5 13.8281C7.225 13.8281 7 13.6031 7 13.3281V6.82812C7 6.55312 7.225 6.32812 7.5 6.32812C7.775 6.32812 8 6.55312 8 6.82812ZM10.5 6.82812V13.3281C10.5 13.6031 10.275 13.8281 10 13.8281C9.725 13.8281 9.5 13.6031 9.5 13.3281V6.82812C9.5 6.55312 9.725 6.32812 10 6.32812C10.275 6.32812 10.5 6.55312 10.5 6.82812Z",
    fill: "#DB2828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_1590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.828125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.511afc0e86dd6856c490f1c5d4ba2234.svg";
export { ForwardRef as ReactComponent };